import { useState } from 'react';
import { errorMessage } from '../api';
import { useAuth } from '../auth';

export function Login(): JSX.Element {
  const { signIn } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [clientSlug, setClientSlug] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function submit(event: React.FormEvent): Promise<void> {
    event.preventDefault();
    setBusy(true);
    setError(null);
    try {
      await signIn(email, password, clientSlug.trim() || undefined);
    } catch (caught) {
      setError(errorMessage(caught));
    } finally {
      setBusy(false);
    }
  }

  return (
    <form className="card login" onSubmit={submit}>
      <h1 style={{ marginTop: 0, fontSize: 19 }}>BidManager</h1>
      <p className="muted small" style={{ marginTop: 0 }}>
        Sign in to manage your profiles, bidders, and bid record.
      </p>

      <div className="field">
        <label htmlFor="email">Email</label>
        <input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} autoFocus required />
      </div>
      <div className="field">
        <label htmlFor="password">Password</label>
        <input id="password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required />
      </div>
      <div className="field">
        <label htmlFor="slug">Client (only if this email is used by more than one)</label>
        <input id="slug" value={clientSlug} onChange={(e) => setClientSlug(e.target.value)} />
      </div>

      {error && <p className="error small">{error}</p>}

      <button className="primary" type="submit" disabled={busy} style={{ width: '100%' }}>
        {busy ? 'Signing in…' : 'Sign in'}
      </button>
    </form>
  );
}
